<script>
  import {SupportMenu} from "@util/constant.js"
  import LargeMenuItem from "./LargeMenuItem.svelte"

</script>


<LargeMenuItem Menu={SupportMenu} ColumnNumber={2} />
